export const SET_HISTORICO_LANCAMENTO = 'SET_HISTORICO_LANCAMENTO'
export const SET_HISTORICOS_LANCAMENTOS = 'SET_HISTORICOS_LANCAMENTOS'
export const ADD_HISTORICOS_LANCAMENTOS = 'ADD_HISTORICOS_LANCAMENTOS'
export const UPDATE_HISTORICOS_LANCAMENTOS = 'UPDATE_HISTORICOS_LANCAMENTOS'
export const REMOVE_HISTORICOS_LANCAMENTOS = 'REMOVE_HISTORICOS_LANCAMENTOS'
export const OPEN_HISTORICO_LANCAMENTO = 'OOPEN_HISTORICO_LANCAMENTOPEN';
export const CLOSE_HISTORICO_LANCAMENTO = 'CLOSE_HISTORICO_LANCAMENTO';